module.exports = __webpack_public_path__ + "7a413a237ab08365c18274165fa59b31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/ride/apple-touch-icon.png
// module id = 1848
// module chunks = 1